import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Common/Button';
import { AuthContext } from '../contexts/AuthContext';

export default function ComingSoon() {
  const navigate = useNavigate();
  const { isAuthenticated, isAllowed, firebaseUser, logout } =
    useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated || (isAllowed && firebaseUser)) {
      navigate('/');
    }
  }, [isAuthenticated, isAllowed, firebaseUser, navigate]);

  return (
    <>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-indigo-600">
            Be patiant we are almost there
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            BetterFunnel is coming soon...
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Logout and try a different account if you have early access
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button
              size="large"
              onClick={() => {
                logout();
              }}
            >
              Logout
            </Button>
            <a href="#" className="text-sm font-semibold text-gray-900">
              Contact support <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </main>
    </>
  );
}
